import { getPageRoute } from './common';
const spaRoutes = [
  'login',
  'help',
  'setUser',
  ['door', 'login/door', 'login/door'],
  ['strategySetting', 'setUser', 'setUser/strategySetting'],
  ['strategyView', 'setUser/strategyView', 'setUser/strategyView'],
  ['strategyEdit', 'setUser/strategyEdit', 'setUser/strategyEdit'],
  'registerAuth',
  'setUp',
  ['staffManagement', 'setUp/staffManagement', 'staffManagement'],
  ['doctorManagement', 'setUp/doctorManagement', 'doctorManagement'],
  ['doctorInfo', 'setUp/doctorManagement/doctorInfo', 'doctorInfo'],
  ['representManagement', 'setUp/representManagement', 'representManagement'],
  ['representDetaill', 'setUp/representManagement/detaill', 'representDetaill'],
  ['hospitalManagement', 'setUp/hospitalManagement', 'hospitalManagement'],
  [
    'hospitalDetail',
    'setUp/hospitalManagement/hospitalDetail',
    'setUp/hospitalManagement/hospitalDetail',
  ],
  'addressList',
  ['addressList', 'addressList/labelEdit', 'addressList/labelEdit'],
  'protocol',
  'dataCenter',
  'register',
  'articleManagement',
  'artilceList',
  ['addArtilce', 'artilceList/addArtilce', 'artilceList/addArtilce'],
  'rosterList',
  ['rosterDetail', 'rosterList/rosterDetail', 'rosterList/rosterDetail'],
  'examBankManagement', // 题库管理
  ['detailExamBank', 'examBankManagement/detailExamBank', 'examBankManagement/detailExamBank'],
  ['addExam', 'examBankManagement/addExam', 'examBankManagement/addExam'],
  'examPaperManagement',
  'commentManagement',
  'voteManagement',
  ['votingDetail', 'voteManagement/votingDetail', 'voteManagement/votingDetail'],
  ['addVoting', 'voteManagement/addVoting', 'voteManagement/addVoting'],
  'publicSet',
  'setManager',
  'enterprisesSet',
  'outAppSet',
  'operationManagement',
  ['operationManagementEdit', 'operationManagement/edit', 'operationManagement/edit'],
  'materialManagement',
  [
    'material-img-upload',
    'materialManagement/material-img-upload',
    'materialManagement/material-img-upload',
  ],
  [
    'material-audio-upload',
    'materialManagement/material-audio-upload',
    'materialManagement/material-audio-upload',
  ],
  [
    'material-video-upload',
    'materialManagement/material-video-upload',
    'materialManagement/material-video-upload',
  ],
  ['docDetail', 'materialManagement/docDetail', 'materialManagement/docDetail'],
  'tagSet',
  'articleData',
  'meetingData',
  ['meetingDataDetail', 'meetingData/meetingDetail', 'meetingData/meetingDetail'],
  [
    'meetingOrganizersDetail',
    'meetingData/meetingOrganizersDetail',
    'meetingData/meetingOrganizersDetail',
  ],
  'meetingSet',
  'userData', // 用户数据
  'chattingRecords', // 会话留存
  ['conversationView', 'chattingRecords/conversationView', 'chattingRecords/conversationView'], // 会话检索
  ['sensitiveWords', 'chattingRecords/sensitiveWords', 'chattingRecords/sensitiveWords'], // 敏感词
  'enterpriseRedPacket',
  'externalContactManagement',
  [
    'externalContactManagementRecords',
    'externalContactManagement/records',
    'externalContactManagement/records',
  ],
  'applicationManagement', // 应用管理
  [
    'applicationDetail',
    'applicationManagement/applicationDetail',
    'applicationManagement/applicationDetail',
  ],
  'externalContactsTransfer', // 外部联系人转移
  'agentSet', // 企业微信设置
  ['autoReply', 'messageManagement/messageReply', 'autoReply'],
  ['addAutoReply', 'messageManagement/messageReply/addReply', 'addAutoReply'],
  ['MessageList', 'messageManagement/messageList', 'MessageList'],
  ['userMessageList', 'messageManagement/messageList/userMessageList', 'userMessageList'],
  'webSiteMsgManagement', // 站内信管理
  ['add', 'webSiteMsgManagement/add', 'webSiteMsgManagement/add'],
].map((r) => (typeof r === 'string' ? getPageRoute([r]) : getPageRoute(r)));
export default spaRoutes;
